<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Inserisci progetto">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn btn-outline-primary mt-3 mr-2" ngbDropdownToggle id="progettoDettaglioAzioni">
                        Azioni
                        <app-toolkit-bl-icon icon="arrow-down-triangle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="progettoDettaglioAzioni">
                        <button ngbDropdownItem [routerLink]="['..']">
                            <app-toolkit-bl-icon icon="arrow-left" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                            Torna indietro
                        </button>
                    </div>
                </div>
            </app-toolkit-page-title>
            <div class="steppers">
    <app-toolkit-progetto-tab-anagrafica-progetto [canEdit]="true" [formGroup]="criteriaForm"></app-toolkit-progetto-tab-anagrafica-progetto>

    <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-outline-primary mr-2" (click)="recuperaDatiCup()">Conferma</button>
        <button type="button" class="btn btn-primary" (click)="inserisciProgetto()" [disabled]="!isConfirmed">Salva</button>
    </div>
</div>
        </div>
    </div>
</div>